// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NNHafXr-{background:#b1ec52;border-radius:100%;color:#000;cursor:pointer;display:flex;height:3rem;width:3rem}@media(hover:hover){.NNHafXr-:hover{filter:brightness(120%)}}@media(hover:none){.NNHafXr-:active{filter:brightness(120%)}}.NNHafXr-:active{filter:brightness(80%)}.NNHafXr- svg{height:1rem}.NNHafXr- svg *{fill:currentColor}@media(max-width:991.98px){.NNHafXr-{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"back": "NNHafXr-"
};
module.exports = ___CSS_LOADER_EXPORT___;
